<template>
    <div class="container">
        <div class="picture">
            <icon class="img" icon="user"/>
        </div>
        <div class="layer"></div>
        <div class="infos">
            <span class="name">
            {{ profileInfo.name }}<br>
            </span>
            <span class="side">
            {{ profileInfo.side }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'profile',
    props: [
        'profileInfo',
    ],
}
</script>

<style lang="stylus" scoped>
.container {
    position: relative;
    padding: 12px;
    display: flex;
    width: 100%;
    height: 100%;
    .picture {
        width: 100px;
        height: 100px;
        background-color: #0159b3;
        border-radius: 50%;
        z-index: 99;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        .img {
            height: 50%;
            width: 50%;
            color: #24292e;
        }
    }
    .layer {
        position: absolute;
        clip-path: polygon(0 0, 100% 0, 90% 100%, 0% 100%);
        align-self: center;
        background-color: #24292e;
        width: 90%;
        height: 70%;
        left: 10%;
    }
    .infos {
        position: absolute;
        clip-path: polygon(0 0, 96% 0, 86% 100%, 0% 100%)
        align-self: center;
        width: 90%;
        height: 70%;
        left: 10%;
        background: silver;

        text-align: left;
        .name {
            padding-left: 75px;
        }
        .side {
            padding-left: 85px;
        }
    }
}

@media screen and (max-width: 950px) {
   .name {
       padding-left: 80px !important;
   }
   .side {
       padding-left: 90px !important;
   }
   .infos {
       left: 13% !important;
   }
   .layer {
       left: 13% !important;
   }
}

@media screen and (max-width: 650px) {
   .infos {
       display: none;
   }
   .layer {
       display:none;
   }
   .container {
       justify-content: center;
   }
}

</style>